import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DifficultyService {
  constructor() {}

  convertDifficultyToPersian(difficulty: string) {
    switch (difficulty) {
      case 'easy':
        return 'آسان';
      case 'medium':
        return 'متوسط';
      case 'hard':
        return 'سخت';
    }
  }

  convertDifficultyToKG(difficulty: string) {
    switch (difficulty) {
      case 'easy':
        return 2;
      case 'medium':
        return 3;
      case 'hard':
        return 4;
    }
  }
}
